import { MotionPlayer } from '@af/design-system-docs-ui/motion-player';
import { Code } from '@atlaskit/code';
import SectionMessage from '@atlaskit/section-message';
import { withAssetPrefix } from 'gatsby';
import EasingCurves from "../../../../src/pages/foundations/motion/_components/_easing-curves";
import MotionProperties from "../../../../src/pages/foundations/motion/_components/_motion-properties";
import Transitions from "../../../../src/pages/foundations/motion/_components/_transitions";
import doWorkflowFriction from "../../../../src/pages/foundations/motion/_assets/do-workflow-friction.png";
import dontWaitWithoutReason from "../../../../src/pages/foundations/motion/_assets/dont-wait-without-reason.png";
import doFocalPoint from "../../../../src/pages/foundations/motion/_assets/do-focal-point.png";
import dontFocalPoint from "../../../../src/pages/foundations/motion/_assets/dont-focal-point.png";
import brandMoments from "../../../../src/pages/foundations/motion/_assets/brand-moments.png";
import * as React from 'react';
export default {
  MotionPlayer,
  Code,
  SectionMessage,
  withAssetPrefix,
  EasingCurves,
  MotionProperties,
  Transitions,
  doWorkflowFriction,
  dontWaitWithoutReason,
  doFocalPoint,
  dontFocalPoint,
  brandMoments,
  React
};